<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter">Abbreviations and Acronyms</p>
<p>AMTORG: Soviet trade company in New York City</p>
<p>AVP RF: Soviet Foreign Policy Archive of the Russian Federation</p>
<p>CC: Central Committee of the Communist Party</p>
<p>Cheka: Extraordinary Commission for Combating Counterrevolution and Sabotage. Founded 1918. Precursor of other state security organizations: GPU, OGPU, NKVD, NKGB, MGB, and KGB</p>
<p>ENIGMA: German encryption machine</p>
<p>FSB: Federal Security Service</p>
<p>GKO: State Defense Committee, 1941–45</p>
<p>GPU: State Political Directorate, 1923–34</p>
<p>GRU: Chief Intelligence Directorate (Military Intelligence)</p>
<p>GTU: Chief Transport Directorate, NKVD</p>
<p>GUGB: Chief Directorate for State Security, NKVD</p>
<p>GULAG: Chief Directorate of Prison Camps</p>
<p>GUPV: Chief Directorate of Border Troops</p>
<p>JIC: British Joint Intelligence Committee</p>
<p>MGB: Ministry of State Security</p>
<p>MI-5: British Counterintelligence Organization</p>
<p>MI-6: British Secret Intelligence Service</p>
<p>Narkom: Acronym for People’s Commissar</p>
<p>NKGB: People’s Commissariat for State Security</p>
<p>NKID: People’s Commissariat for Foreign Affairs</p>
<p>NKO: People’s Commissariat for Defense</p>
<p>NKPS: People’s Commissariat of Transport Routes</p>
<p>NKVD: People’s Commissariat for Internal Affairs</p>
<p>OKW: High Command of the German Armed Forces</p>
<p>OUN: Organization of Ukrainian Nationalists</p>
<p>PVO: National Air Defense</p>
<p>RF: Russian Federation</p>
<p>RGVA: Russian State Military Archive</p>
<p>RKKA: Workers and Peasants Red Army</p>
<p>RU: Military Intelligence Directorate</p>
<p>RU GS KA: Intelligence Directorate, General Staff, Red Army</p>
<p>SIS: British Secret Intelligence Service (MI-6)</p>
<p>SMD: Special Military District</p>
<p>SNK: Council of People’s Commissars</p>
<p>Stavka: Highest organ of strategic leadership of the Soviet armed forces during World War II</p>
<p>SVR: Russian Foreign Intelligence Service</p>
<p>ULTRA: Code word for British decryption of German codes</p>
<p>VENONA: Declassified messages obtained by Anglo-American decryption of Soviet codes</p>
<p>VKP(b): All-Union Communist Party (Bolsheviks)</p>
<p>VNOS: Soviet air observation, warning, and communications service</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbr.vue?97daa98c